import React, { useRef, useState } from 'react';
import { useLoadScript, DrawingManager, GoogleMap, Polygon, useJsApiLoader } from '@react-google-maps/api';
import { useEffect } from 'react';

const libraries = ['drawing'];

const GoogleMapDraw = (props) => {
    const mapRef = useRef();
    const polygonRefs = useRef([]);
    const drawingManagerRef = useRef();

    const { isLoaded, loadError } = useLoadScript({
        // googleMapsApiKey: 'AIzaSyC4FYOWLg6zN9o9BCi8Kc3kb5FreGJXqgg',
        googleMapsApiKey: props.GoogleMapApiKeyLoc,
        libraries
    });

    const [polygon, setPolygon] = useState([]);
    const defaultCenter = { lat: 15.2501627762245, lng: 74.0782077379068 };
    const [center, setCenter] = useState(defaultCenter);
    const [isNewPolygon, setIsNewPolygon] = useState(false);

    const calculateAverage = (array) => {
        var total = 0;
        array.forEach(function(item, index) {
            total += item;
        });
        return total / array.length;
      }

useEffect(()=>{
    setPolygon(props.defaultPolygon);
    if(isNewPolygon == false && props.defaultPolygon.length > 0)
    {
        let avgLat = calculateAverage(props.defaultPolygon.map(x => x.lat));
        let avgLng = calculateAverage(props.defaultPolygon.map(x => x.lng));
        setCenter({ lat: avgLat, lng: avgLng });
    }
    setIsNewPolygon(false);
}, [props.defaultPolygon]);

    const deleteIconStyle = {
        position: 'absolute',
        top: '5px',
        left: '56.5%',
        border: 'none',
        fontSize: '12px',
        paddingLeft: '5px',
        paddingRight: '5px',
        height: '24px',
        lineHeight: '16px',
        borderRadius: '0 2px 2px 0',
        background: '#fff',
        borderLeft: '1px solid #ddd',
        zIndex: '99999 !important'
    }

    const polygonOptions = {
        strokeColor: '#0000ff',
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: '#333d72',
        fillOpacity: 0.4,
        draggable: true,
        editable: true
    }

    const drawingManagerOptions = {
        polygonOptions: polygonOptions,
        drawingControl: true,
        drawingControlOptions: {
            position: window.google?.maps?.ControlPosition?.TOP_CENTER,
            drawingModes: [window.google?.maps?.drawing?.OverlayType?.POLYGON]
        }
    }

    const onLoadMap = (map) => {
        mapRef.current = map;
    }

    const onLoadPolygon = (polygon) => {
        polygonRefs.current = polygon;
    }

    const onLoadDrawingManager = drawingManager => {
        drawingManagerRef.current = drawingManager;
    }

    const onOverlayComplete = ($overlayEvent) => {
        drawingManagerRef.current.setDrawingMode(null);
        if ($overlayEvent.type === window.google.maps.drawing.OverlayType.POLYGON) {
            const newPolygon = $overlayEvent.overlay.getPath()
                .getArray()
                .map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }))

            // start and end point should be same for valid geojson
            const startPoint = newPolygon[0];
            newPolygon.push(startPoint);
            $overlayEvent.overlay?.setMap(null);
            setPolygon([newPolygon]);
            setIsNewPolygon(true);
            props.onparentCallback({ newLocationCords: newPolygon});
        }
    }

    const onDeleteDrawing = () => {
        setPolygon([]);
        props.onparentCallback({ newLocationCords: []});
    }

    const onEditPolygon = () => {
        const polygonRef = polygonRefs.current;
        if (polygonRef) {
            const coordinates = polygonRef.getPath()
                .getArray()
                .map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }));
            setPolygon(coordinates)
            props.onparentCallback({ newLocationCords: coordinates});
        }
    }

    return (
        isLoaded
            ?
            <div>
                <GoogleMap
                    options={{
                        mapTypeControl: false,
                        mapTypeId: window.google.maps.MapTypeId.HYBRID,
                        mapTypeControlOptions: {
                          style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                          position: window.google.maps.ControlPosition.LEFT_BOTTOM,
                          mapTypeIds: [
                            window.google.maps.MapTypeId.ROADMAP,
                            window.google.maps.MapTypeId.SATELLITE,
                            window.google.maps.MapTypeId.HYBRID,
                          ],
                        },
                        streetViewControl:false
                      }}
                    defaultZoom={props.defaultZoom ?? 17}
                    zoom={props.defaultZoom ?? 17}
                    defaultCenter={center}
                    center={center}
                    onLoad={onLoadMap}
                    mapContainerStyle={props.defaultMapSize ??{ width: '100%', height: '351px', borderRadius: '10px' }}
                >
                    <DrawingManager
                        onLoad={onLoadDrawingManager}
                        onOverlayComplete={onOverlayComplete}
                        options={drawingManagerOptions}
                    />
                    {
                        (polygon !== null && polygon.length > 0 &&
                            <Polygon
                                onLoad={(event) => onLoadPolygon(event)}
                                onMouseUp={() => onEditPolygon()}
                                onDragEnd={() => onEditPolygon()}
                                options={polygonOptions}
                                paths={polygon}
                            />)
                    }
                </GoogleMap>
                {
                    drawingManagerRef.current
                    &&
                    <button title='Delete shape' className="polygondelbtn" style={deleteIconStyle} onClick={onDeleteDrawing}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 50 50"
                      width="15px"
                      height="20px"
                    >
                      <path d="M 21 0 C 19.355469 0 18 1.355469 18 3 L 18 5 L 10.1875 5 C 10.0625 4.976563 9.9375 4.976563 9.8125 5 L 8 5 C 7.96875 5 7.9375 5 7.90625 5 C 7.355469 5.027344 6.925781 5.496094 6.953125 6.046875 C 6.980469 6.597656 7.449219 7.027344 8 7 L 9.09375 7 L 12.6875 47.5 C 12.8125 48.898438 14.003906 50 15.40625 50 L 34.59375 50 C 35.996094 50 37.1875 48.898438 37.3125 47.5 L 40.90625 7 L 42 7 C 42.359375 7.003906 42.695313 6.816406 42.878906 6.503906 C 43.058594 6.191406 43.058594 5.808594 42.878906 5.496094 C 42.695313 5.183594 42.359375 4.996094 42 5 L 32 5 L 32 3 C 32 1.355469 30.644531 0 29 0 Z M 21 2 L 29 2 C 29.5625 2 30 2.4375 30 3 L 30 5 L 20 5 L 20 3 C 20 2.4375 20.4375 2 21 2 Z M 11.09375 7 L 38.90625 7 L 35.3125 47.34375 C 35.28125 47.691406 34.910156 48 34.59375 48 L 15.40625 48 C 15.089844 48 14.71875 47.691406 14.6875 47.34375 Z M 18.90625 9.96875 C 18.863281 9.976563 18.820313 9.988281 18.78125 10 C 18.316406 10.105469 17.988281 10.523438 18 11 L 18 44 C 17.996094 44.359375 18.183594 44.695313 18.496094 44.878906 C 18.808594 45.058594 19.191406 45.058594 19.503906 44.878906 C 19.816406 44.695313 20.003906 44.359375 20 44 L 20 11 C 20.011719 10.710938 19.894531 10.433594 19.6875 10.238281 C 19.476563 10.039063 19.191406 9.941406 18.90625 9.96875 Z M 24.90625 9.96875 C 24.863281 9.976563 24.820313 9.988281 24.78125 10 C 24.316406 10.105469 23.988281 10.523438 24 11 L 24 44 C 23.996094 44.359375 24.183594 44.695313 24.496094 44.878906 C 24.808594 45.058594 25.191406 45.058594 25.503906 44.878906 C 25.816406 44.695313 26.003906 44.359375 26 44 L 26 11 C 26.011719 10.710938 25.894531 10.433594 25.6875 10.238281 C 25.476563 10.039063 25.191406 9.941406 24.90625 9.96875 Z M 30.90625 9.96875 C 30.863281 9.976563 30.820313 9.988281 30.78125 10 C 30.316406 10.105469 29.988281 10.523438 30 11 L 30 44 C 29.996094 44.359375 30.183594 44.695313 30.496094 44.878906 C 30.808594 45.058594 31.191406 45.058594 31.503906 44.878906 C 31.816406 44.695313 32.003906 44.359375 32 44 L 32 11 C 32.011719 10.710938 31.894531 10.433594 31.6875 10.238281 C 31.476563 10.039063 31.191406 9.941406 30.90625 9.96875 Z" />
                    </svg>
                  </button>
                }
            </div>
            :
            null
    );
}

export default GoogleMapDraw;
